import type { Doc as YDoc } from 'yjs';

const revisions = new WeakMap<YDoc, { value: number }>();

/**
 * Monotonic change counter for a row shard Y.Doc. Unlike a state vector it
 * also advances on delete-only transactions (row delete), so caches keyed on
 * it never serve rows that were removed locally or by a remote peer.
 */
export function getShardDocRevision(doc: YDoc): number {
  let revision = revisions.get(doc);
  if (!revision) {
    const tracked = { value: 0 };
    doc.on('update', () => {
      tracked.value += 1;
    });
    revisions.set(doc, tracked);
    revision = tracked;
  }
  return revision.value;
}
